import ConsentedStubModel from './consented-stub';
import DissentedStubModel from './dissented-stub';
import { searchParams } from '../util/location';
import debug, { WARN } from '../util/debug';
export default function (backendBaseUrl, Dflt, clientConsentString, geoInfo, legislation, pVendorList) {
    if (searchParams['mol.ads.cmp.stubConsent']) {
        debug('stubbing consent', WARN);
        return ConsentedStubModel.load(backendBaseUrl, clientConsentString, geoInfo, legislation, pVendorList);
    }
    else if (searchParams['mol.ads.cmp.stubDissent']) {
        debug('stubbing dissent', WARN);
        return DissentedStubModel.load(backendBaseUrl, clientConsentString, geoInfo, legislation, pVendorList);
    }
    else {
        debug(`load consent: ${clientConsentString}`);
        return Dflt.load(backendBaseUrl, clientConsentString, geoInfo, legislation, pVendorList);
    }
}
